import {initSmartLook, initUsetiful} from '../../../init-scripts/init-scripts';

export async function onLoad(): Promise<void> {
    initUsetiful();
    initSmartLook();

    return Promise.resolve();
}
